import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../Components/auth/firebaseConfig';

const cleanBaseUrl = (value = '') => String(value || '').replace(/\/$/, '');

export const callBackendFunction = async ({
  baseUrl,
  name,
  payload = {},
}) => {
  const normalizedBaseUrl = cleanBaseUrl(baseUrl);
  if (!normalizedBaseUrl) {
    const callable = httpsCallable(functions, name);
    const response = await callable(payload);
    return response?.data || {};
  }

  const headers = {
    'Content-Type': 'application/json',
  };
  const token = await auth.currentUser?.getIdToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${normalizedBaseUrl}/${name}`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ data: payload }),
  });

  const body = await response.json().catch(() => ({}));
  if (!response.ok || body?.error) {
    const message = body?.error?.message || body?.message || `Request failed for ${name}.`;
    throw new Error(message);
  }

  return body?.result || body?.data || {};
};
